import CurrentLevels from './components/currentLevels';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import React, {useEffect, useState} from 'react';
import API from '../../../app/api';
import {setSnackbar} from '../../../store/reducers/globals';
import {hasPermission, Permissions} from '../../../store/reducers/user';
import EscalationChange from './components/escalationChange';

export const useStylesEscalationLevel = makeStyles((theme) => ({
    container: {
        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#626466',
        padding: 10,
        borderRadius: 4,
    },
    table: {
        maxHeight: '400px !important',
    },
    bold: {
        fontWeight: 'bold',
    },
    row: {
        marginTop: 10,
        '&.right': {
            marginLeft: 'auto',
        },
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    escalationLevel: {
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        width: '70px',
        borderRadius: 5,
        height: '25px',
        lineHeight: '14px',
        fontWeight: 700,
        border: '1px solid transparent',
        paddingTop: 1,
        fontSize: '12px',
        '&.core': {
            borderColor: '#4EAC6F',
            color: '#4EAC6F',
        },
        '&.planned': {
            borderColor: '#F7A202',
            color: '#F7A202',
        },
        '&.unplanned': {
            borderColor: '#E25B61',
            color: '#E25B61',
        },
    },
    statsChip: {
        backgroundColor: theme.palette.mode === 'light' ? '#e3e3e3' : '#434343',
        borderRadius: 6,
        textAlign: 'center',
        padding: 6,
        width: '100%',
    },
    statsCount: {
        fontSize: 'large',
    },
}));

const EscalationLevel = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Form states
    const [levels, setLevels] = useState([]);

    // Permission
    const canEscalation = dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_ESCALATION));

    useEffect(() => {
        reloadData();
    }, []);

    const reloadData = () => {
        API.getEscalationLevels()
            .then(res => {
                setLevels(res || []);
            })
            .catch(() => {
                dispatch(setSnackbar({type: 'error', message: t('Unable to retrieve escalation levels.')}));
            });
    };

    return (
        <>
            <CurrentLevels levels={levels}/>
            {canEscalation && <EscalationChange levels={levels} reloadData={reloadData} fromAdminPage/>}
        </>
    );
};

export default EscalationLevel;